import { createContext, useContext } from "react";
import { useDoctors } from "@/hooks/use-doctors";
import { useVisits } from "@/hooks/use-visits";
import { usePeriod } from "@/hooks/use-period";
import { usePlans } from "@/hooks/use-plans";
import { useProducts } from "@/hooks/use-products";
import { useZones } from "@/hooks/use-zones";
import { useApoios } from "@/hooks/use-apoios";
import { useTodos } from "@/hooks/use-todos";

type DataContextType = {
  doctors: ReturnType<typeof useDoctors>;
  visits: ReturnType<typeof useVisits>;
  period: ReturnType<typeof usePeriod>;
  plans: ReturnType<typeof usePlans>;
  products: ReturnType<typeof useProducts>;
  zones: ReturnType<typeof useZones>;
  apoios: ReturnType<typeof useApoios>;
  todos: ReturnType<typeof useTodos>;
};

const DataContext = createContext<DataContextType | null>(null);

export function DataProvider({ children }: { children: React.ReactNode }) {
  const doctors = useDoctors();
  const visits = useVisits();
  const period = usePeriod();
  const plans = usePlans();
  const products = useProducts();
  const zones = useZones();
  const apoios = useApoios();
  const todos = useTodos();

  return (
    <DataContext.Provider
      value={{ doctors, visits, period, plans, products, zones, apoios, todos }}
    >
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  const ctx = useContext(DataContext);
  if (!ctx) throw new Error("useData must be used within DataProvider");
  return ctx;
}
